/**
 * Human-readable aspect-ratio label for a media asset.
 *
 * Snaps to the ratio names the ad team actually thinks in (Meta's placement
 * ratios plus the common camera ones) when the media is within 3% of one —
 * 1200×628 reads as "1.91:1", not "300:157". Anything else falls back to a
 * normalised decimal so the label stays short and comparable.
 */
const KNOWN_RATIOS: Array<{ label: string; value: number }> = [
  { label: "9:16", value: 9 / 16 },
  { label: "2:3", value: 2 / 3 },
  { label: "3:4", value: 3 / 4 },
  { label: "4:5", value: 4 / 5 },
  { label: "1:1", value: 1 },
  { label: "4:3", value: 4 / 3 },
  { label: "3:2", value: 3 / 2 },
  { label: "16:9", value: 16 / 9 },
  { label: "1.91:1", value: 1.91 },
]

const TOLERANCE = 0.03

export function aspectRatioLabel(
  width?: number | null,
  height?: number | null,
): string | null {
  if (!width || !height || width <= 0 || height <= 0) return null
  const ratio = width / height
  const hit = KNOWN_RATIOS.find(
    r => Math.abs(ratio - r.value) / r.value <= TOLERANCE,
  )
  if (hit) return hit.label
  return ratio >= 1 ? `${ratio.toFixed(2)}:1` : `1:${(1 / ratio).toFixed(2)}`
}
